import type { ICtaUrlInterpolationContext } from '@lucimark/shared/helpers/substituteCtaUrlTemplate'
import type { IQueueFrame } from '@/types'

export function buildCtaInterpolationContext(params: {
  tenantId: string
  playerId: string
  playerTitle: string
  venueId?: string | null
  tenantHandle?: string | null
  scheduleRootUrn?: string | null
  frame: IQueueFrame
}): ICtaUrlInterpolationContext {
  return {
    tenantId: params.tenantId,
    playerId: params.playerId,
    playerTitle: params.playerTitle,
    venueId: params.venueId ?? null,
    tenantHandle: params.tenantHandle ?? null,
    playlistUrn: params.frame.playlistUrn,
    frameId: params.frame.id,
    contentSourcePlaylistUrn: params.frame.contentSourcePlaylistUrn ?? null,
    scheduleRootUrn: params.scheduleRootUrn ?? null
  }
}
